<template>
  <div class="modal fade" id="versionsModalInfo" tabindex="-1" aria-labelledby="versionsModalInfoLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="clientModalLabel">
            Версии
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div class="mb-5 rounded border p-5" v-for="item in getVersion">
            <div class="fw-bold mb-3" v-html="item.version"></div>
            <section class="text-gray-700 version-description" v-html="item.description"></section>
          </div>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFull from '@/components/Main/LoaderFull'

export default {
  name: 'VersionsModal',
  components: {
    LoaderFull,
  },
  data() {
    return {
      loader: false
    }
  },
  mounted() {
    this.getVersionRequest()
  },
  computed: {
    getVersion() { return this.$store.getters.getVersions },
  },
  methods: {
    getVersionRequest() {
      if (!this.getVersion) {
        this.loader = true
        this.$store.dispatch('versionsRequest').finally(() => this.loader = false)
      }
    },
  },
}
</script>

<style scoped>

</style>